/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Subjectlabel3Inputs */

const en_coinvestments_editemail_subjectlabel3 = /** @type {(inputs: Coinvestments_Editemail_Subjectlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Coinvestments_Editemail_Subjectlabel3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_subjectlabel3 = /** @type {((inputs?: Coinvestments_Editemail_Subjectlabel3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Subjectlabel3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_subjectlabel3(inputs)
});
export { coinvestments_editemail_subjectlabel3 as "coInvestments_editEmail_subjectLabel" }